// extracted by mini-css-extract-plugin
export var error = "dateInput-module--error--31acd";
export var icon = "dateInput-module--icon--83fea";
export var iconWrapper = "dateInput-module--icon-wrapper--5f26d";
export var wrapper = "dateInput-module--wrapper--22884";
export var wrapperDarkTheme = "dateInput-module--wrapper-dark-theme--0433f";